import { TextTranslationType } from "../types/textTranslationType";
import store from "../store";

export function getCurrentLangTextOrFirst(translations?: Array<TextTranslationType>) {
  const appLang = store.getState().persisted.appLanguage;
  if (!translations) return "Текст";
  return translations.find((it) => it.language?.langCode === appLang)?.text || translations.at(0)?.text || "";
}
